import { render, staticRenderFns } from "./LiquidacionResumen.vue?vue&type=template&id=74a3ebd0"
import script from "./LiquidacionResumen.vue?vue&type=script&lang=js"
export * from "./LiquidacionResumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports